import React, { Fragment } from 'react'
import { Tabs, Swiper, List, Avatar, Toast, Modal, DotLoading, Divider } from 'antd-mobile'
import { SwiperRef } from 'antd-mobile/es/components/swiper'
import { Game } from './types'
import dayjs from 'dayjs'
import {
    ExclamationTriangleOutline
} from 'antd-mobile-icons'
import { useClipboard } from 'use-clipboard-copy'
dayjs().locale('zh-cn');
// const PLayStatus = { "play": "进行中", "wait": "未开始" }
const ExcludeDomain = ["www.zhibodou.com", "live.qq.com"];
const getState = (statusText: string, league: string) => {
    if (league.includes("延期")) return <div style={{ color: 'gray', }}>已延期</div>;
    if (statusText.includes("观看直播")) return <div style={{ color: '#1677ff', }}>进行中</div>;
    if (statusText.includes("已结束")) return <div style={{ color: 'gray' }}>已结束</div>;
    return <div style={{ color: 'gray' }}>未开始</div>
}
const weeks = ["日", "一", "二", "三", "四", "五", "六"]
const getDayTitle = (dayStr: string) => {

    const today = dayjs().format("YYYY-MM-DD")
    const date = dayjs(dayStr, "YYYY-MM-DD")
    const md = date.format("MM-DD")
    const diff = date.diff(today, 'day')
    if (diff >= 0 && diff <= 2) {
        return `${md} ${['今天', '明天', '后天'][diff]}`;
    }

    const d = +date.format("d")
    return `${md} 周${weeks[d]}`
}

const getVideoList = (videoDataStr: string) => {
    if (!videoDataStr?.trim()) return [];
    const videoMap: Record<string, string> = JSON.parse(videoDataStr);
    return Object.entries(videoMap).filter(([k, v]) => {
        try {
            const url = new URL(v);
            return !ExcludeDomain.includes(url.host);
        } catch (e) {
            return false;
        }

    }).map(([k, v]) => ({ label: k, value: v }))
}

const getAvatar = (url: string, domain: string) => {
    // console.log("img url :", url)
    if (url === '/images/default.png') {
        return '/logo192.png'
    }
    return `${domain}${url}`
}

export const CategoryTabs = (props: { c: string, games: Game[], domain: string }) => {
    const { c, games, domain } = props;
    const swiperRef = React.useRef<SwiperRef>(null)
    const [activeIndex, setActiveIndex] = React.useState(0)

    const list = React.useMemo(() => games.filter(g => c === '0' ? g.hot : g.c === c).map(g => ({ ...g, l: g.l === '体育' ? '其他' : g.l, date: dayjs(new Date(+g.st * 1000)) })), [c, games]);
    const dayList = React.useMemo(() => Array.from(new Set(list.map(g => g.date.format("YYYY-MM-DD")))), [list]);

    const leagues = React.useMemo(() => {
        const set = new Set(list.map(g => g.l));
        if (set.has("其他")) {
            set.delete('其他')
            return ["全部", ...Array.from(set).sort(), "其他"]
        }
        return ["全部", ...Array.from(set).sort()]

    }, [list,]);
    const clipboard = useClipboard();
    // console.log("activeIndex", activeIndex)
    // console.log("leagues", leagues)
    React.useEffect(() => setActiveIndex(0), [c]);


    const openPlay = (game: Game, url: string) => {
        // const u = window.encodeURIComponent(url)
        // const b = window.encodeURI(domain)
        // const { title, gtName, htName } = game;
        // const t = window.encodeURI(title || `${gtName} VS ${htName}`)
        // window.open(`play.html?u=${u}&b=${b}&t=${t}`)

        Modal.show({
            content: '在微信里建议复制地址到浏览器中打开',
            closeOnAction: true,
            closeOnMaskClick: true,
            actions: [
                {
                    key: 'online',
                    text: '直接打开',
                    primary: true,
                    onClick: () => { window.open(url); }
                },

                {
                    key: 'share',
                    text: '复制地址',
                    onClick: () => {
                        clipboard.copy(url);
                        Toast.show({
                            content: '复制成功，请打开浏览粘贴到地址栏打开',
                            icon: 'success',
                            duration: 5
                        })
                    }
                },
            ],
        })
    }

    const openGame = (game: Game) => {
        // console.log("game", game)
        if (game.league.includes("延期")) {
            Toast.show({
                content: '比赛已延期',
                icon: <ExclamationTriangleOutline />,
            })
            return;
        }
        if (!game.statusText.includes("观看直播")) {
            Toast.show({
                content: '比赛未在进行中',
                icon: <ExclamationTriangleOutline />,
            })
            return;
        }
        const videos = getVideoList(game.videos || "");
        if (videos.length === 0) {
            Toast.show({
                content: '暂时没有信号',
                icon: <ExclamationTriangleOutline />,
            })
            return;
        }

        // console.log("videos", videos)

        Modal.show({
            content: <>
                <List header="请选择观看信号">
                    {videos.map((t, i) => <List.Item key={i} onClick={() => openPlay(game, t.value)}>
                        {t.label}
                    </List.Item>)}

                </List>
            </>,
            closeOnMaskClick: true,
        })
    }
    return !domain
        ? <div style={{ textAlign: 'center', padding: 100 }}>
            <DotLoading color='primary' />
        </div>
        : <>
            <div style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 9999 }}>
                <Tabs
                    activeKey={leagues[activeIndex]}
                    onChange={key => {
                        const index = leagues.findIndex(item => item === key)
                        console.log("key", key, "index", index)
                        setActiveIndex(index)
                        swiperRef.current?.swipeTo(index)
                        document.getElementById("root")?.scrollTo(0, 0);
                    }}
                >
                    {leagues.map((item, i) => (
                        <Tabs.Tab title={item} key={item} />
                    ))}
                </Tabs>
            </div>
            <Swiper
                direction='horizontal'
                loop
                indicator={() => null}
                ref={swiperRef}
                defaultIndex={activeIndex}
                onIndexChange={index => {
                    setActiveIndex(index)
                    document.getElementById("root")?.scrollTo(0, 0);
                }}
            >
                {
                    leagues.map(l => <Swiper.Item key={l} style={{ backgroundColor: '#8080800f' }}>
                        {

                            dayList.map((d, i) => {
                                const games = list.filter(g => (l === '全部' || g.l === l) && g.date.format("YYYY-MM-DD") === d);
                                if (games.length === 0) return <Fragment key={i}></Fragment>
                                return <List key={i} header={<span style={{}}>{getDayTitle(d)}</span>}>
                                    {

                                        games.map((g, j) => <List.Item key={j}
                                            prefix={<div style={{ fontSize: 12, color: 'gray', textAlign: 'center' }} >
                                                <div>{g.date.format("HH:mm")}</div>
                                                <div style={{ fontSize: 10, }}>{getState(g.statusText, g.league)}</div>
                                            </div>}
                                            onClick={() => openGame(g)}>
                                            {
                                                g.title
                                                    ? <div className="game" key={g.href}>{g.title}</div>
                                                    : <div className="game-container" key={g.href}>
                                                        <div style={{ flex: 1, display: 'flex' }}>
                                                            <div style={{ flex: 1, textAlign: 'right', padding: "4px 10px 0 0" }}>{g.htName}</div>
                                                            <Avatar src={getAvatar(g.htNameAvatar, domain)} style={{ '--size': '32px' }} lazy />
                                                        </div>
                                                        <div className='game-league'>{g.league}</div>
                                                        <div style={{ flex: 1, display: 'flex', }}>
                                                            <Avatar src={getAvatar(g.gtNameAvatar, domain)} style={{ '--size': '32px' }} lazy />
                                                            <div style={{ flex: 1, padding: "4px  0 0 10px" }}>{g.gtName}</div>
                                                        </div>
                                                    </div>
                                            }
                                        </List.Item>)
                                    }


                                </List>
                            })


                        }
                        <Divider style={{ borderStyle: 'dashed', fontSize: 10, margin: 0, padding: "12px 0", backgroundColor: 'white' }}>没有了</Divider>
                    </Swiper.Item>)
                }

            </Swiper>

        </>
}